import Header from '../../components/Header/Header';
import Aside from '../../components/Aside/Aside';
import './Report.css'

const Report = () => {
    return (
        <>
            <Header />
            <Aside />
            <main>
                <section className='containerhome'>
                    <h1 className='titulo1'>Relatório</h1>
                </section>

            </main>
        </>
    )
}

export default Report
